var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8767",
    "data-name": "Group 8767",
    transform: "translate(1758 -2878)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_681",
    "data-name": "Ellipse 681",
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    transform: "translate(-1758 2878)",
    fill: "#00cb85",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_682",
    "data-name": "Ellipse 682",
    cx: 19.877,
    cy: 19.877,
    r: 19.877,
    transform: "translate(-1752.378 2883.622)",
    fill: "#00cb85",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_683",
    "data-name": "Ellipse 683",
    cx: 14.255,
    cy: 14.255,
    r: 14.255,
    transform: "translate(-1746.698 2889.302)",
    fill: "#00cb85",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Check_1813701",
    transform: "translate(-1739.844 2898.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7051",
    "data-name": "Group 7051",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5801",
    "data-name": "Path 5801",
    d: "M13.567,0a1,1,0,0,0-.689.305C10.392,2.8,7.732,5.652,5.248,8.171L1.7,5.252A1,1,0,1,0,.435,6.793L4.692,10.3a1,1,0,0,0,1.346-.063c2.692-2.7,5.613-5.858,8.264-8.514A1,1,0,0,0,13.567,0Z",
    fill: "#00cb85"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.85660eb76d7f58d013c81bf63bce2d49.svg";
export { ForwardRef as ReactComponent };